import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer270 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_70: Record<
  Exclude<PageIdWoofzOffer270, PageIdWoofzOffer270.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer270.SUBSCRIPTIONS_OFFER2_70]: {
    id: PageIdWoofzOffer270.SUBSCRIPTIONS_OFFER2_70,
    hasHeader: false,
  },
  [PageIdWoofzOffer270.CHAT_UPSELL_OFFER2_70]: {
    id: PageIdWoofzOffer270.CHAT_UPSELL_OFFER2_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer270.UPSELL_OFFER2_70]: {
    id: PageIdWoofzOffer270.UPSELL_OFFER2_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer270.DOWNLOAD_OFFER2_70]: {
    id: PageIdWoofzOffer270.DOWNLOAD_OFFER2_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
